import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import ConfirmationPage from '../../ConfirmationPage/ConfirmationPage';
import { getHasMutualFundPaperlessConfirmations } from '../../../../redux/modules/user/Paperless/paperless.selectors';
import CollegeBrandingContainer from '../../../Shared/CollegeBrandingContainer/CollegeBrandingContainer';
import CollegeDistributeWhatsNext from '../../WhatsNext/CollegeDistribute/CollegeDistributeWhatsNext';
import {
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
  isSalesforceRep,
} from '../../../../redux/modules/authentication/authentication.module.selectors';
import {
  getHasMixedCollegeTypes,
  getProductTypes,
} from '../../../../redux/modules/productTypes/productType.selectors';

const CollegeDistributeConfirmation = ({
  isIFrame,
  isSalesforceRep,
  customerWebViewEnabled,
  confirmationNumber,
  hasPaperless,
  tradeDate,
  transactions,
  isDistributeToSchool,
  selectedProductTypes,
  hasMultiple529Products,
}) => (
  <CollegeBrandingContainer>
    <ConfirmationPage
      isIFrame={isIFrame}
      isSalesforceRep={isSalesforceRep}
      customerWebViewEnabled={customerWebViewEnabled}
      confirmationNumber={confirmationNumber}
      hasPaperless={hasPaperless}
      heroTitle="Your distribution has been submitted!"
      tradeDate={tradeDate}
      transactions={transactions}
      whatsNext={CollegeDistributeWhatsNext}
      isDistributeToSchool={isDistributeToSchool}
      selectedProductTypes={selectedProductTypes}
      hasMultiple529Products={hasMultiple529Products}
    />
  </CollegeBrandingContainer>
);

const mapStateToProps = (state) => {
  const {
    executeRedemption: {
      redemption: {
        confirmationNumber,
        successfulTransactions: transactions,
        tradeDate,
      },
    },
    isDistributeToSchool,
  } = state;

  return {
    isIFrame: isEmbeddedInIFrame(state),
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    confirmationNumber,
    hasPaperless: getHasMutualFundPaperlessConfirmations(state),
    tradeDate,
    transactions,
    isDistributeToSchool,
    selectedProductTypes: getProductTypes(state),
    hasMultiple529Products: getHasMixedCollegeTypes(state),
  };
};

export default compose(connect(mapStateToProps))(CollegeDistributeConfirmation);
